import { AdminLayout } from '@/layouts/AdminLayout';
import { DetailProjectLayout } from '@/layouts/DetailProjectLayout';
import { Dashboard } from '@/pages/Dashboard';
import { ListCustomField } from '@/pages/customField/ListCustomField';
import { ListModule } from '@/pages/module/ListModule';
import { CreateEditProject } from '@/pages/project/CreateEditProject';
import { ListProject } from '@/pages/project/ListProject';
import { OverviewProject } from '@/pages/project/OverviewProject';
import { CreateEditRelease } from '@/pages/release/CreateEditRelease';
import { DetailRelease } from '@/pages/release/DetailRelease';
import { ListArchiveRelease } from '@/pages/release/ListArchiveRelease';
import { ListRelease } from '@/pages/release/ListRelease';
import { CreateEditTestCase } from '@/pages/testCase/CreateEditTestCase';
import { DetailTestCase } from '@/pages/testCase/DetailTestCase';
import { ListArchiveTestCase } from '@/pages/testCase/ListArchiveTestCase';
import { ListTestCase } from '@/pages/testCase/ListTestCase';
import { CreateEditTestIssue } from '@/pages/testIssue/CreateEditTestIssue';
import { ListTestIssue } from '@/pages/testIssue/ListTestIssue';
import { ListArchiveTestIssue } from '@/pages/testIssue/ListArchiveTestIssue';
import { ShareTestIssue } from '@/pages/testIssue/ShareIssue';
import { CreateEditTestPlan } from '@/pages/testPlan/CreateEditTestPlan';
import { ListTestPlan } from '@/pages/testPlan/ListTestPlan';
import { CreateEditTestRun } from '@/pages/testRun/CreateEditTestRun';
import { DetailTestRun } from '@/pages/testRun/DetailTestRun';
import { ListArchiveTestRun } from '@/pages/testRun/ListArchiveTestRun';
import { ListTestRun } from '@/pages/testRun/ListTestRun';
import { ShareDetailTestRun } from '@/pages/testRun/ShareDetailTestRun';
import { CreateEditUser } from '@/pages/user/CreateEditUser';
import { ListUser } from '@/pages/user/ListUser';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { AdministratorLayout } from '@/layouts/AdministratorLayout';
import { DetailTestPlan } from '@/pages/testPlan/DetailTestPlan';
import { ListArchiveTestPlan } from '@/pages/testPlan/ListArchiveTestPlan';
import { CreateEditCustomField } from '@/pages/customField/CreateEditCustomField';
import { DetailTestIssue } from '@/pages/testIssue/DetailTestIssue';
import { ListArchiveModule } from '@/pages/module/ListArchiveModule';
import { RolesGate } from './RolesGate';
import { AccessType } from '@/utils/constants/users';
import { WorkerDashboard } from '@/pages/worker/WorkerDashboard';

export const routes: RouteObject[] = [
  {
    path: 'public',
    element: <ProtectedRoute layout={Outlet} isPublic />,
    children: [
      {
        path: 'shareable/release/:releaseId',
        element: <DetailRelease />,
      },
      {
        path: 'shareable/test-run/:testRunId',
        element: <ShareDetailTestRun />,
      },
      {
        path: 'shareable/test-run/:testRunId?moduleId=:moduleId',
        element: <ShareDetailTestRun />,
      },
      {
        path: 'shareable/test-issue/:id',
        element: <ShareTestIssue />,
      },
    ],
  },
  {
    element: <ProtectedRoute layout={AdminLayout} />,
    path: 'custom-field',
    children: [
      {
        index: true,
        element: <ListCustomField />,
      },
    ],
  },
  {
    element: <ProtectedRoute layout={AdminLayout} />,
    children: [
      { index: true, element: <Dashboard /> },
      // dashboard QC 
      {
        path: 'worker',
        element: (
          <RolesGate roles={[AccessType.ADMIN]}>
            <WorkerDashboard />
          </RolesGate>
        ),
      },

      // administrator
      {
        path: 'user',
        element: (
          <RolesGate roles={[AccessType.ADMIN]}>
            <AdministratorLayout />
          </RolesGate>
        ),
        children: [
          { index: true, element: <ListUser /> },
          { path: ':id/edit', element: <CreateEditUser /> },
          {
            path: 'custom-field',
            children: [
              { index: true, element: <ListCustomField /> },
              { path: 'create', element: <CreateEditCustomField /> },
              { path: ':id/edit', element: <CreateEditCustomField /> },
            ],
          },
        ],
      },

      {
        path: 'project',
        children: [
          { index: true, element: <ListProject /> },
          { path: 'create', element: <CreateEditProject /> },

          // detail project
          {
            path: ':id',
            element: <DetailProjectLayout />,
            children: [
              { index: true, element: <OverviewProject /> },
              { path: 'module', element: <ListModule /> },
              { path: 'test-case', element: <ListTestCase /> },
              { path: 'release', element: <ListRelease /> },
              { path: 'test-run', element: <ListTestRun /> },
              { path: 'test-run/:testRunId', element: <DetailTestRun /> },
              { path: 'test-issue', element: <ListTestIssue /> },
              { path: 'test-plan', element: <ListTestPlan /> },
            ],
          },

          // detail project without layout
          {
            path: ':id',
            children: [
              { path: 'edit', element: <CreateEditProject /> },

              // test-case
              {
                path: 'test-case',
                children: [
                  { path: 'create', element: <CreateEditTestCase /> },
                  { path: 'archive', element: <ListArchiveTestCase /> },
                  {
                    path: ':testCaseId',
                    children: [
                      { index: true, element: <DetailTestCase /> },
                      {
                        path: 'edit',
                        element: <CreateEditTestCase />,
                      },
                      {
                        path: 'clone',
                        element: <CreateEditTestCase />,
                      },
                      {
                        path: 'test-issues',
                        element: <Navigate to={'..'} replace />,
                      },
                      {
                        path: 'test-issues/create',
                        element: <CreateEditTestIssue />,
                      },
                      {
                        path: 'test-issues/:testIssueId',
                        element: <Navigate to={'..'} replace />,
                      },
                      {
                        path: 'test-issues/:testIssueId/edit',
                        element: <Navigate to={'..'} replace />,
                      },
                    ],
                  },
                ],
              },

              //  release
              {
                path: 'release',
                children: [
                  { path: 'create', element: <CreateEditRelease /> },
                  { path: 'archive', element: <ListArchiveRelease /> },
                  {
                    path: ':releaseId',
                    element: <DetailRelease />,
                  },
                  {
                    path: ':releaseId/edit',
                    element: <CreateEditRelease />,
                  },
                ],
              },

              // test-run
              {
                path: 'test-run',
                children: [
                  { path: 'create', element: <CreateEditTestRun /> },
                  { path: 'archive', element: <ListArchiveTestRun /> },
                  {
                    path: ':testRunId',
                    children: [
                      {
                        path: 'test-run-detail',
                        element: <Navigate to={'..'} replace />,
                      },
                      {
                        path: 'edit',
                        element: <CreateEditTestRun />,
                      },
                      {
                        path: 'result/create',
                        element: <Navigate to={'..'} replace />,
                      },
                    ],
                  },
                ],
              },

              //test issue
              {
                path: 'test-issue',
                children: [
                  { path: 'create', element: <CreateEditTestIssue /> },
                  { path: 'archive', element: <ListArchiveTestIssue /> },
                  { path: ':testIssueId', element: <DetailTestIssue /> },
                  {
                    path: ':testIssueId/edit',
                    element: <CreateEditTestIssue />,
                  },
                ],
              },

              //test plan
              {
                path: 'test-plan',
                children: [
                  { path: 'create', element: <CreateEditTestPlan /> },
                  { path: 'archive', element: <ListArchiveTestPlan /> },
                  { path: ':testPlanId', element: <DetailTestPlan /> },
                  { path: ':testPlanId/edit', element: <CreateEditTestPlan /> },
                ],
              },

              // module
              {
                path: 'module',
                children: [
                  { path: 'archive', element: <ListArchiveModule /> },
                  { path: 'archive/:testCaseId', element: <DetailTestCase /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
